import script from "./DashboardLeftColumn.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashboardLeftColumn.vue?vue&type=script&lang=ts&setup=true"

import "./DashboardLeftColumn.vue?vue&type=style&index=0&id=783676c8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-783676c8"]])

export default __exports__